import { List, Map, Record } from 'immutable';

export default Record({
    id: 6,
    pivot: Map({
        days: null,
        values: Map({}),
    }),
    requiredFields: List([
        Map({
            key: 'product_name',
            label: 'Short Product Name',
        }),
        Map({
            key: 'asin',
            label: 'ASIN',
        }),
    ]),
    template: 'We hope you are loving your {product_name} please take a moment to review the item on [Amazon](https://www.amazon.com/review/create-review?asin={asin}) Every time you review an item a fairy gets its wings!',
    title: 'Basic Amazon Followup',
    type: 'SCHEDULED',
});
